import Tracking from '../../../../../pages/vip/features/tracking/index';

export default Tracking;
